export default {
  page: (state) => {
    return state.pagination.page || 1;
  },
};
